import React from 'react';
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
  useSearchParams,
} from 'react-router-dom';

export default function withRouterHooks(Component) {
  return function WrappedComponent(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = useSearchParams();
    const params = useParams();
    const outletContext = useOutletContext();

    return (
      <Component
        {...props}
        location={location}
        navigate={navigate}
        outletContext={outletContext}
        params={params}
        searchParams={searchParams}
      />
    );
  };
}
